import { PendingSyncSalesOrderListPage } from '@/features/pending-sync-sales-order/pages/PendingSyncSalesOrderListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/pending-sync-sales-order/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["it.monitoring.pending_sales_order"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PendingSyncSalesOrderListPage,
})
